// GET /api/v1/talent_surveys/:id
import {generateFetchOptions} from '../../index';

export async function fetchTalentSurveyData(talentSurveyId: string): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/talent_surveys/${talentSurveyId}`,
    generateFetchOptions({method: 'GET', isProtected: false})
  );
}
